export function getFields(ocrResult) {
  return {
    nameFields: [
      {
        id: "lastName",
        text: "Nume",
        value: ocrResult?.lastName,
        size: 4,
      },
      {
        id: "firstName1",
        text: "Prenume 1",
        value: ocrResult?.firstName1,
        size: 4,
      },
      {
        id: "firstName2",
        text: "Prenume 2",
        value: ocrResult?.firstName2,
        size: 4,
      },
    ],
    idCardFields: [
      {
        id: "idCardType",
        text: "Tip",
        value: ocrResult?.idType,
        size: 2,
      },
      {
        id: "cnp",
        text: "CNP",
        value: ocrResult?.cnp,
        size: 5,
      },
      {
        id: "gender",
        text: "Sex",
        value: ocrResult?.gender,
        size: 2,
      },
      {
        id: "idCardSeries",
        text: "Serie CI",
        value: ocrResult?.idSeries,
        size: 3,
      },
      {
        id: "idCardNumber",
        text: "Număr CI",
        value: ocrResult?.idNumber,
        size: 4,
      },
      {
        id: "validityStartDate",
        text: "Valabil de la",
        value: ocrResult?.dateOfIssue,
        size: 4,
      },
      {
        id: "validityEndDate",
        text: "Valabil până la",
        value: ocrResult?.expiryDate,
        size: 4,
      },
      {
        id: "nationality",
        text: "Naționalitate",
        value: ocrResult?.nationality,
        size: 3,
      },
    ],
    birthFields: [
      {
        id: "birthLocality",
        text: "Localitatea nașterii",
        value: ocrResult?.placeOfBirth,
        size: 8,
      },
      {
        id: "birthDate",
        text: "Data nașterii",
        value: ocrResult?.dateOfBirth,
        size: 4,
      },
    ],
    addressFields: [
      {
        id: "streetType",
        text: "Tip stradă",
        value: ocrResult?.streetType,
        size: 3,
      },
      {
        id: "streetName",
        text: "Strada",
        value: ocrResult?.streetName,
        size: 6,
      },
      {
        id: "streetNumber",
        text: "Număr",
        value: ocrResult?.streetNumber,
        size: 3,
      },
      {
        id: "buildingNumber",
        text: "Bloc",
        value: ocrResult?.buildingNumber,
        size: 3,
      },
      {
        id: "entranceNumber",
        text: "Scară",
        value: ocrResult?.entranceNumber,
        size: 3,
      },
      {
        id: "floorNumber",
        text: "Etaj",
        value: ocrResult?.floorNumber,
        size: 3,
      },
      {
        id: "apartmentNumber",
        text: "Apartament",
        value: ocrResult?.apartmentNumber,
        size: 3,
      },
      {
        id: "county",
        text: "Județ / Sector",
        value:
          ocrResult?.county == null && ocrResult?.uatName === "Bucureşti"
            ? `${ocrResult?.localityType} ${ocrResult?.localityName}`
            : ocrResult?.county,
        size: 3,
      },
      {
        id: "localityType",
        text: "Tip localitate",
        value: ocrResult?.uatType,
        size: 3,
      },
      {
        id: "locality",
        text: "Localitate",
        value:
          ocrResult?.uatName +
          (ocrResult?.localityType == null ||
          ocrResult?.localityName == null ||
          (ocrResult?.county == null && ocrResult?.uatName === "Bucureşti")
            ? ""
            : `, ${ocrResult?.localityType} ${ocrResult?.localityName}`),
        size: 6,
      },
    ],
  };
}
